import React from 'react'
import './Loading.css'

function Loading() {
  return (
    <div className='Loding'>
      <span class="loader"></span>
    </div>
  )
}

export default Loading
